export const namespaced = true

export const state = {
  dataCultures: [
    { cultureCode: 'af', name: 'Afrikaans' },
    { cultureCode: 'af-NA', name: 'Afrikaans (Namibia)' },
    { cultureCode: 'af-ZA', name: 'Afrikaans (South Africa)' },
    { cultureCode: 'ak', name: 'Akan' },
    { cultureCode: 'ak-GH', name: 'Akan (Ghana)' },
    { cultureCode: 'sq', name: 'Albanian' },
    { cultureCode: 'sq-AL', name: 'Albanian (Albania)' },
    { cultureCode: 'sq-XK', name: 'Albanian (Kosovo)' },
    { cultureCode: 'sq-MK', name: 'Albanian (Macedonia)' },
    { cultureCode: 'am', name: 'Amharic' },
    { cultureCode: 'am-ET', name: 'Amharic (Ethiopia)' },
    { cultureCode: 'ar', name: 'Arabic' },
    { cultureCode: 'ar-DZ', name: 'Arabic (Algeria)' },
    { cultureCode: 'ar-BH', name: 'Arabic (Bahrain)' },
    { cultureCode: 'ar-TD', name: 'Arabic (Chad)' },
    { cultureCode: 'ar-KM', name: 'Arabic (Comoros)' },
    { cultureCode: 'ar-DJ', name: 'Arabic (Djibouti)' },
    { cultureCode: 'ar-EG', name: 'Arabic (Egypt)' },
    { cultureCode: 'ar-ER', name: 'Arabic (Eritrea)' },
    { cultureCode: 'ar-IQ', name: 'Arabic (Iraq)' },
    { cultureCode: 'ar-IL', name: 'Arabic (Israel)' },
    { cultureCode: 'ar-JO', name: 'Arabic (Jordan)' },
    { cultureCode: 'ar-KW', name: 'Arabic (Kuwait)' },
    { cultureCode: 'ar-LB', name: 'Arabic (Lebanon)' },
    { cultureCode: 'ar-LY', name: 'Arabic (Libya)' },
    { cultureCode: 'ar-MR', name: 'Arabic (Mauritania)' },
    { cultureCode: 'ar-MA', name: 'Arabic (Morocco)' },
    { cultureCode: 'ar-OM', name: 'Arabic (Oman)' },
    { cultureCode: 'ar-PS', name: 'Arabic (Palestinian Territories)' },
    { cultureCode: 'ar-QA', name: 'Arabic (Qatar)' },
    { cultureCode: 'ar-SA', name: 'Arabic (Saudi Arabia)' },
    { cultureCode: 'ar-SO', name: 'Arabic (Somalia)' },
    { cultureCode: 'ar-SS', name: 'Arabic (South Sudan)' },
    { cultureCode: 'ar-SD', name: 'Arabic (Sudan)' },
    { cultureCode: 'ar-SY', name: 'Arabic (Syria)' },
    { cultureCode: 'ar-TN', name: 'Arabic (Tunisia)' },
    { cultureCode: 'ar-AE', name: 'Arabic (United Arab Emirates)' },
    { cultureCode: 'ar-EH', name: 'Arabic (Western Sahara)' },
    { cultureCode: 'ar-YE', name: 'Arabic (Yemen)' },
    { cultureCode: 'hy', name: 'Armenian' },
    { cultureCode: 'hy-AM', name: 'Armenian (Armenia)' },
    { cultureCode: 'as', name: 'Assamese' },
    { cultureCode: 'as-IN', name: 'Assamese (India)' },
    { cultureCode: 'az', name: 'Azerbaijani' },
    { cultureCode: 'az-AZ', name: 'Azerbaijani (Azerbaijan)' },
    { cultureCode: 'az-Cyrl-AZ', name: 'Azerbaijani (Cyrillic, Azerbaijan)' },
    { cultureCode: 'az-Cyrl', name: 'Azerbaijani (Cyrillic)' },
    { cultureCode: 'az-Latn-AZ', name: 'Azerbaijani (Latin, Azerbaijan)' },
    { cultureCode: 'az-Latn', name: 'Azerbaijani (Latin)' },
    { cultureCode: 'bm', name: 'Bambara' },
    { cultureCode: 'bm-Latn-ML', name: 'Bambara (Latin, Mali)' },
    { cultureCode: 'bm-Latn', name: 'Bambara (Latin)' },
    { cultureCode: 'eu', name: 'Basque' },
    { cultureCode: 'eu-ES', name: 'Basque (Spain)' },
    { cultureCode: 'be', name: 'Belarusian' },
    { cultureCode: 'be-BY', name: 'Belarusian (Belarus)' },
    { cultureCode: 'bn', name: 'Bengali' },
    { cultureCode: 'bn-BD', name: 'Bengali (Bangladesh)' },
    { cultureCode: 'bn-IN', name: 'Bengali (India)' },
    { cultureCode: 'bs', name: 'Bosnian' },
    { cultureCode: 'bs-BA', name: 'Bosnian (Bosnia & Herzegovina)' },
    { cultureCode: 'bs-Cyrl-BA', name: 'Bosnian (Cyrillic, Bosnia & Herzegovina)' },
    { cultureCode: 'bs-Cyrl', name: 'Bosnian (Cyrillic)' },
    { cultureCode: 'bs-Latn-BA', name: 'Bosnian (Latin, Bosnia & Herzegovina)' },
    { cultureCode: 'bs-Latn', name: 'Bosnian (Latin)' },
    { cultureCode: 'br', name: 'Breton' },
    { cultureCode: 'br-FR', name: 'Breton (France)' },
    { cultureCode: 'bg', name: 'Bulgarian' },
    { cultureCode: 'bg-BG', name: 'Bulgarian (Bulgaria)' },
    { cultureCode: 'my', name: 'Burmese' },
    { cultureCode: 'my-MM', name: 'Burmese (Myanmar (Burma))' },
    { cultureCode: 'ca', name: 'Catalan' },
    { cultureCode: 'ca-AD', name: 'Catalan (Andorra)' },
    { cultureCode: 'ca-FR', name: 'Catalan (France)' },
    { cultureCode: 'ca-IT', name: 'Catalan (Italy)' },
    { cultureCode: 'ca-ES', name: 'Catalan (Spain)' },
    { cultureCode: 'zh', name: 'Chinese' },
    { cultureCode: 'zh-CN', name: 'Chinese (China)' },
    { cultureCode: 'zh-HK', name: 'Chinese (Hong Kong SAR China)' },
    { cultureCode: 'zh-MO', name: 'Chinese (Macau SAR China)' },
    { cultureCode: 'zh-Hans-CN', name: 'Chinese (Simplified, China)' },
    { cultureCode: 'zh-Hans-HK', name: 'Chinese (Simplified, Hong Kong SAR China)' },
    { cultureCode: 'zh-Hans-MO', name: 'Chinese (Simplified, Macau SAR China)' },
    { cultureCode: 'zh-Hans-SG', name: 'Chinese (Simplified, Singapore)' },
    { cultureCode: 'zh-Hans', name: 'Chinese (Simplified)' },
    { cultureCode: 'zh-SG', name: 'Chinese (Singapore)' },
    { cultureCode: 'zh-TW', name: 'Chinese (Taiwan)' },
    { cultureCode: 'zh-Hant-HK', name: 'Chinese (Traditional, Hong Kong SAR China)' },
    { cultureCode: 'zh-Hant-MO', name: 'Chinese (Traditional, Macau SAR China)' },
    { cultureCode: 'zh-Hant-TW', name: 'Chinese (Traditional, Taiwan)' },
    { cultureCode: 'zh-Hant', name: 'Chinese (Traditional)' },
    { cultureCode: 'kw', name: 'Cornish' },
    { cultureCode: 'kw-GB', name: 'Cornish (United Kingdom)' },
    { cultureCode: 'hr', name: 'Croatian' },
    { cultureCode: 'hr-BA', name: 'Croatian (Bosnia & Herzegovina)' },
    { cultureCode: 'hr-HR', name: 'Croatian (Croatia)' },
    { cultureCode: 'cs', name: 'Czech' },
    { cultureCode: 'cs-CZ', name: 'Czech (Czech Republic)' },
    { cultureCode: 'da', name: 'Danish' },
    { cultureCode: 'da-DK', name: 'Danish (Denmark)' },
    { cultureCode: 'da-GL', name: 'Danish (Greenland)' },
    { cultureCode: 'nl', name: 'Dutch' },
    { cultureCode: 'nl-AW', name: 'Dutch (Aruba)' },
    { cultureCode: 'nl-BE', name: 'Dutch (Belgium)' },
    { cultureCode: 'nl-BQ', name: 'Dutch (Caribbean Netherlands)' },
    { cultureCode: 'nl-CW', name: 'Dutch (Curaçao)' },
    { cultureCode: 'nl-NL', name: 'Dutch (Netherlands)' },
    { cultureCode: 'nl-SX', name: 'Dutch (Sint Maarten)' },
    { cultureCode: 'nl-SR', name: 'Dutch (Suriname)' },
    { cultureCode: 'dz', name: 'Dzongkha' },
    { cultureCode: 'dz-BT', name: 'Dzongkha (Bhutan)' },
    { cultureCode: 'en', name: 'English' },
    { cultureCode: 'en-AS', name: 'English (American Samoa)' },
    { cultureCode: 'en-AI', name: 'English (Anguilla)' },
    { cultureCode: 'en-AG', name: 'English (Antigua & Barbuda)' },
    { cultureCode: 'en-AU', name: 'English (Australia)' },
    { cultureCode: 'en-BS', name: 'English (Bahamas)' },
    { cultureCode: 'en-BB', name: 'English (Barbados)' },
    { cultureCode: 'en-BE', name: 'English (Belgium)' },
    { cultureCode: 'en-BZ', name: 'English (Belize)' },
    { cultureCode: 'en-BM', name: 'English (Bermuda)' },
    { cultureCode: 'en-BW', name: 'English (Botswana)' },
    { cultureCode: 'en-IO', name: 'English (British Indian Ocean Territory)' },
    { cultureCode: 'en-VG', name: 'English (British Virgin Islands)' },
    { cultureCode: 'en-CM', name: 'English (Cameroon)' },
    { cultureCode: 'en-CA', name: 'English (Canada)' },
    { cultureCode: 'en-KY', name: 'English (Cayman Islands)' },
    { cultureCode: 'en-CX', name: 'English (Christmas Island)' },
    { cultureCode: 'en-CC', name: 'English (Cocos (Keeling) Islands)' },
    { cultureCode: 'en-CK', name: 'English (Cook Islands)' },
    { cultureCode: 'en-DG', name: 'English (Diego Garcia)' },
    { cultureCode: 'en-DM', name: 'English (Dominica)' },
    { cultureCode: 'en-ER', name: 'English (Eritrea)' },
    { cultureCode: 'en-FK', name: 'English (Falkland Islands)' },
    { cultureCode: 'en-FJ', name: 'English (Fiji)' },
    { cultureCode: 'en-GM', name: 'English (Gambia)' },
    { cultureCode: 'en-GH', name: 'English (Ghana)' },
    { cultureCode: 'en-GI', name: 'English (Gibraltar)' },
    { cultureCode: 'en-GD', name: 'English (Grenada)' },
    { cultureCode: 'en-GU', name: 'English (Guam)' },
    { cultureCode: 'en-GG', name: 'English (Guernsey)' },
    { cultureCode: 'en-GY', name: 'English (Guyana)' },
    { cultureCode: 'en-HK', name: 'English (Hong Kong SAR China)' },
    { cultureCode: 'en-IN', name: 'English (India)' },
    { cultureCode: 'en-IE', name: 'English (Ireland)' },
    { cultureCode: 'en-IM', name: 'English (Isle of Man)' },
    { cultureCode: 'en-JM', name: 'English (Jamaica)' },
    { cultureCode: 'en-JE', name: 'English (Jersey)' },
    { cultureCode: 'en-KE', name: 'English (Kenya)' },
    { cultureCode: 'en-KI', name: 'English (Kiribati)' },
    { cultureCode: 'en-LS', name: 'English (Lesotho)' },
    { cultureCode: 'en-LR', name: 'English (Liberia)' },
    { cultureCode: 'en-MO', name: 'English (Macau SAR China)' },
    { cultureCode: 'en-MG', name: 'English (Madagascar)' },
    { cultureCode: 'en-MW', name: 'English (Malawi)' },
    { cultureCode: 'en-MY', name: 'English (Malaysia)' },
    { cultureCode: 'en-MT', name: 'English (Malta)' },
    { cultureCode: 'en-MH', name: 'English (Marshall Islands)' },
    { cultureCode: 'en-MU', name: 'English (Mauritius)' },
    { cultureCode: 'en-FM', name: 'English (Micronesia)' },
    { cultureCode: 'en-MS', name: 'English (Montserrat)' },
    { cultureCode: 'en-NA', name: 'English (Namibia)' },
    { cultureCode: 'en-NR', name: 'English (Nauru)' },
    { cultureCode: 'en-NZ', name: 'English (New Zealand)' },
    { cultureCode: 'en-NG', name: 'English (Nigeria)' },
    { cultureCode: 'en-NU', name: 'English (Niue)' },
    { cultureCode: 'en-NF', name: 'English (Norfolk Island)' },
    { cultureCode: 'en-MP', name: 'English (Northern Mariana Islands)' },
    { cultureCode: 'en-PK', name: 'English (Pakistan)' },
    { cultureCode: 'en-PW', name: 'English (Palau)' },
    { cultureCode: 'en-PG', name: 'English (Papua New Guinea)' },
    { cultureCode: 'en-PH', name: 'English (Philippines)' },
    { cultureCode: 'en-PN', name: 'English (Pitcairn Islands)' },
    { cultureCode: 'en-PR', name: 'English (Puerto Rico)' },
    { cultureCode: 'en-RW', name: 'English (Rwanda)' },
    { cultureCode: 'en-WS', name: 'English (Samoa)' },
    { cultureCode: 'en-SC', name: 'English (Seychelles)' },
    { cultureCode: 'en-SL', name: 'English (Sierra Leone)' },
    { cultureCode: 'en-SG', name: 'English (Singapore)' },
    { cultureCode: 'en-SX', name: 'English (Sint Maarten)' },
    { cultureCode: 'en-SB', name: 'English (Solomon Islands)' },
    { cultureCode: 'en-ZA', name: 'English (South Africa)' },
    { cultureCode: 'en-SS', name: 'English (South Sudan)' },
    { cultureCode: 'en-SH', name: 'English (St. Helena)' },
    { cultureCode: 'en-KN', name: 'English (St. Kitts & Nevis)' },
    { cultureCode: 'en-LC', name: 'English (St. Lucia)' },
    { cultureCode: 'en-VC', name: 'English (St. Vincent & Grenadines)' },
    { cultureCode: 'en-SD', name: 'English (Sudan)' },
    { cultureCode: 'en-SZ', name: 'English (Swaziland)' },
    { cultureCode: 'en-TZ', name: 'English (Tanzania)' },
    { cultureCode: 'en-TK', name: 'English (Tokelau)' },
    { cultureCode: 'en-TO', name: 'English (Tonga)' },
    { cultureCode: 'en-TT', name: 'English (Trinidad & Tobago)' },
    { cultureCode: 'en-TC', name: 'English (Turks & Caicos Islands)' },
    { cultureCode: 'en-TV', name: 'English (Tuvalu)' },
    { cultureCode: 'en-UM', name: 'English (U.S. Outlying Islands)' },
    { cultureCode: 'en-VI', name: 'English (U.S. Virgin Islands)' },
    { cultureCode: 'en-UG', name: 'English (Uganda)' },
    { cultureCode: 'en-GB', name: 'English (United Kingdom)' },
    { cultureCode: 'en-US', name: 'English (United States)' },
    { cultureCode: 'en-VU', name: 'English (Vanuatu)' },
    { cultureCode: 'en-ZM', name: 'English (Zambia)' },
    { cultureCode: 'en-ZW', name: 'English (Zimbabwe)' },
    { cultureCode: 'eo', name: 'Esperanto' },
    { cultureCode: 'et', name: 'Estonian' },
    { cultureCode: 'et-EE', name: 'Estonian (Estonia)' },
    { cultureCode: 'ee', name: 'Ewe' },
    { cultureCode: 'ee-GH', name: 'Ewe (Ghana)' },
    { cultureCode: 'ee-TG', name: 'Ewe (Togo)' },
    { cultureCode: 'fo', name: 'Faroese' },
    { cultureCode: 'fo-FO', name: 'Faroese (Faroe Islands)' },
    { cultureCode: 'fi', name: 'Finnish' },
    { cultureCode: 'fi-FI', name: 'Finnish (Finland)' },
    { cultureCode: 'fr', name: 'French' },
    { cultureCode: 'fr-DZ', name: 'French (Algeria)' },
    { cultureCode: 'fr-BE', name: 'French (Belgium)' },
    { cultureCode: 'fr-BJ', name: 'French (Benin)' },
    { cultureCode: 'fr-BF', name: 'French (Burkina Faso)' },
    { cultureCode: 'fr-BI', name: 'French (Burundi)' },
    { cultureCode: 'fr-CM', name: 'French (Cameroon)' },
    { cultureCode: 'fr-CA', name: 'French (Canada)' },
    { cultureCode: 'fr-CF', name: 'French (Central African Republic)' },
    { cultureCode: 'fr-TD', name: 'French (Chad)' },
    { cultureCode: 'fr-KM', name: 'French (Comoros)' },
    { cultureCode: 'fr-CG', name: 'French (Congo - Brazzaville)' },
    { cultureCode: 'fr-CD', name: 'French (Congo - Kinshasa)' },
    { cultureCode: 'fr-CI', name: 'French (Côte d’Ivoire)' },
    { cultureCode: 'fr-DJ', name: 'French (Djibouti)' },
    { cultureCode: 'fr-GQ', name: 'French (Equatorial Guinea)' },
    { cultureCode: 'fr-FR', name: 'French (France)' },
    { cultureCode: 'fr-GF', name: 'French (French Guiana)' },
    { cultureCode: 'fr-PF', name: 'French (French Polynesia)' },
    { cultureCode: 'fr-GA', name: 'French (Gabon)' },
    { cultureCode: 'fr-GP', name: 'French (Guadeloupe)' },
    { cultureCode: 'fr-GN', name: 'French (Guinea)' },
    { cultureCode: 'fr-HT', name: 'French (Haiti)' },
    { cultureCode: 'fr-LU', name: 'French (Luxembourg)' },
    { cultureCode: 'fr-MG', name: 'French (Madagascar)' },
    { cultureCode: 'fr-ML', name: 'French (Mali)' },
    { cultureCode: 'fr-MQ', name: 'French (Martinique)' },
    { cultureCode: 'fr-MR', name: 'French (Mauritania)' },
    { cultureCode: 'fr-MU', name: 'French (Mauritius)' },
    { cultureCode: 'fr-YT', name: 'French (Mayotte)' },
    { cultureCode: 'fr-MC', name: 'French (Monaco)' },
    { cultureCode: 'fr-MA', name: 'French (Morocco)' },
    { cultureCode: 'fr-NC', name: 'French (New Caledonia)' },
    { cultureCode: 'fr-NE', name: 'French (Niger)' },
    { cultureCode: 'fr-RE', name: 'French (Réunion)' },
    { cultureCode: 'fr-RW', name: 'French (Rwanda)' },
    { cultureCode: 'fr-SN', name: 'French (Senegal)' },
    { cultureCode: 'fr-SC', name: 'French (Seychelles)' },
    { cultureCode: 'fr-BL', name: 'French (St. Barthélemy)' },
    { cultureCode: 'fr-MF', name: 'French (St. Martin)' },
    { cultureCode: 'fr-PM', name: 'French (St. Pierre & Miquelon)' },
    { cultureCode: 'fr-CH', name: 'French (Switzerland)' },
    { cultureCode: 'fr-SY', name: 'French (Syria)' },
    { cultureCode: 'fr-TG', name: 'French (Togo)' },
    { cultureCode: 'fr-TN', name: 'French (Tunisia)' },
    { cultureCode: 'fr-VU', name: 'French (Vanuatu)' },
    { cultureCode: 'fr-WF', name: 'French (Wallis & Futuna)' },
    { cultureCode: 'ff', name: 'Fulah' },
    { cultureCode: 'ff-CM', name: 'Fulah (Cameroon)' },
    { cultureCode: 'ff-GN', name: 'Fulah (Guinea)' },
    { cultureCode: 'ff-MR', name: 'Fulah (Mauritania)' },
    { cultureCode: 'ff-SN', name: 'Fulah (Senegal)' },
    { cultureCode: 'gl', name: 'Galician' },
    { cultureCode: 'gl-ES', name: 'Galician (Spain)' },
    { cultureCode: 'lg', name: 'Ganda' },
    { cultureCode: 'lg-UG', name: 'Ganda (Uganda)' },
    { cultureCode: 'ka', name: 'Georgian' },
    { cultureCode: 'ka-GE', name: 'Georgian (Georgia)' },
    { cultureCode: 'de', name: 'German' },
    { cultureCode: 'de-AT', name: 'German (Austria)' },
    { cultureCode: 'de-BE', name: 'German (Belgium)' },
    { cultureCode: 'de-DE', name: 'German (Germany)' },
    { cultureCode: 'de-LI', name: 'German (Liechtenstein)' },
    { cultureCode: 'de-LU', name: 'German (Luxembourg)' },
    { cultureCode: 'de-CH', name: 'German (Switzerland)' },
    { cultureCode: 'el', name: 'Greek' },
    { cultureCode: 'el-CY', name: 'Greek (Cyprus)' },
    { cultureCode: 'el-GR', name: 'Greek (Greece)' },
    { cultureCode: 'gu', name: 'Gujarati' },
    { cultureCode: 'gu-IN', name: 'Gujarati (India)' },
    { cultureCode: 'ha', name: 'Hausa' },
    { cultureCode: 'ha-GH', name: 'Hausa (Ghana)' },
    { cultureCode: 'ha-Latn-GH', name: 'Hausa (Latin, Ghana)' },
    { cultureCode: 'ha-Latn-NE', name: 'Hausa (Latin, Niger)' },
    { cultureCode: 'ha-Latn-NG', name: 'Hausa (Latin, Nigeria)' },
    { cultureCode: 'ha-Latn', name: 'Hausa (Latin)' },
    { cultureCode: 'ha-NE', name: 'Hausa (Niger)' },
    { cultureCode: 'ha-NG', name: 'Hausa (Nigeria)' },
    { cultureCode: 'he', name: 'Hebrew' },
    { cultureCode: 'he-IL', name: 'Hebrew (Israel)' },
    { cultureCode: 'hi', name: 'Hindi' },
    { cultureCode: 'hi-IN', name: 'Hindi (India)' },
    { cultureCode: 'hu', name: 'Hungarian' },
    { cultureCode: 'hu-HU', name: 'Hungarian (Hungary)' },
    { cultureCode: 'is', name: 'Icelandic' },
    { cultureCode: 'is-IS', name: 'Icelandic (Iceland)' },
    { cultureCode: 'ig', name: 'Igbo' },
    { cultureCode: 'ig-NG', name: 'Igbo (Nigeria)' },
    { cultureCode: 'id', name: 'Indonesian' },
    { cultureCode: 'id-ID', name: 'Indonesian (Indonesia)' },
    { cultureCode: 'ga', name: 'Irish' },
    { cultureCode: 'ga-IE', name: 'Irish (Ireland)' },
    { cultureCode: 'it', name: 'Italian' },
    { cultureCode: 'it-IT', name: 'Italian (Italy)' },
    { cultureCode: 'it-SM', name: 'Italian (San Marino)' },
    { cultureCode: 'it-CH', name: 'Italian (Switzerland)' },
    { cultureCode: 'ja', name: 'Japanese' },
    { cultureCode: 'ja-JP', name: 'Japanese (Japan)' },
    { cultureCode: 'kl', name: 'Kalaallisut' },
    { cultureCode: 'kl-GL', name: 'Kalaallisut (Greenland)' },
    { cultureCode: 'kn', name: 'Kannada' },
    { cultureCode: 'kn-IN', name: 'Kannada (India)' },
    { cultureCode: 'ks', name: 'Kashmiri' },
    { cultureCode: 'ks-Arab-IN', name: 'Kashmiri (Arabic, India)' },
    { cultureCode: 'ks-Arab', name: 'Kashmiri (Arabic)' },
    { cultureCode: 'ks-IN', name: 'Kashmiri (India)' },
    { cultureCode: 'kk', name: 'Kazakh' },
    { cultureCode: 'kk-Cyrl-KZ', name: 'Kazakh (Cyrillic, Kazakhstan)' },
    { cultureCode: 'kk-Cyrl', name: 'Kazakh (Cyrillic)' },
    { cultureCode: 'kk-KZ', name: 'Kazakh (Kazakhstan)' },
    { cultureCode: 'km', name: 'Khmer' },
    { cultureCode: 'km-KH', name: 'Khmer (Cambodia)' },
    { cultureCode: 'ki', name: 'Kikuyu' },
    { cultureCode: 'ki-KE', name: 'Kikuyu (Kenya)' },
    { cultureCode: 'rw', name: 'Kinyarwanda' },
    { cultureCode: 'rw-RW', name: 'Kinyarwanda (Rwanda)' },
    { cultureCode: 'ko', name: 'Korean' },
    { cultureCode: 'ko-KP', name: 'Korean (North Korea)' },
    { cultureCode: 'ko-KR', name: 'Korean (South Korea)' },
    { cultureCode: 'ky', name: 'Kyrgyz' },
    { cultureCode: 'ky-Cyrl-KG', name: 'Kyrgyz (Cyrillic, Kyrgyzstan)' },
    { cultureCode: 'ky-Cyrl', name: 'Kyrgyz (Cyrillic)' },
    { cultureCode: 'ky-KG', name: 'Kyrgyz (Kyrgyzstan)' },
    { cultureCode: 'lo', name: 'Lao' },
    { cultureCode: 'lo-LA', name: 'Lao (Laos)' },
    { cultureCode: 'lv', name: 'Latvian' },
    { cultureCode: 'lv-LV', name: 'Latvian (Latvia)' },
    { cultureCode: 'ln', name: 'Lingala' },
    { cultureCode: 'ln-AO', name: 'Lingala (Angola)' },
    { cultureCode: 'ln-CF', name: 'Lingala (Central African Republic)' },
    { cultureCode: 'ln-CG', name: 'Lingala (Congo - Brazzaville)' },
    { cultureCode: 'ln-CD', name: 'Lingala (Congo - Kinshasa)' },
    { cultureCode: 'lt', name: 'Lithuanian' },
    { cultureCode: 'lt-LT', name: 'Lithuanian (Lithuania)' },
    { cultureCode: 'lu', name: 'Luba-Katanga' },
    { cultureCode: 'lu-CD', name: 'Luba-Katanga (Congo - Kinshasa)' },
    { cultureCode: 'lb', name: 'Luxembourgish' },
    { cultureCode: 'lb-LU', name: 'Luxembourgish (Luxembourg)' },
    { cultureCode: 'mk', name: 'Macedonian' },
    { cultureCode: 'mk-MK', name: 'Macedonian (Macedonia)' },
    { cultureCode: 'mg', name: 'Malagasy' },
    { cultureCode: 'mg-MG', name: 'Malagasy (Madagascar)' },
    { cultureCode: 'ms', name: 'Malay' },
    { cultureCode: 'ms-BN', name: 'Malay (Brunei)' },
    { cultureCode: 'ms-Latn-BN', name: 'Malay (Latin, Brunei)' },
    { cultureCode: 'ms-Latn-MY', name: 'Malay (Latin, Malaysia)' },
    { cultureCode: 'ms-Latn-SG', name: 'Malay (Latin, Singapore)' },
    { cultureCode: 'ms-Latn', name: 'Malay (Latin)' },
    { cultureCode: 'ms-MY', name: 'Malay (Malaysia)' },
    { cultureCode: 'ms-SG', name: 'Malay (Singapore)' },
    { cultureCode: 'ml', name: 'Malayalam' },
    { cultureCode: 'ml-IN', name: 'Malayalam (India)' },
    { cultureCode: 'mt', name: 'Maltese' },
    { cultureCode: 'mt-MT', name: 'Maltese (Malta)' },
    { cultureCode: 'gv', name: 'Manx' },
    { cultureCode: 'gv-IM', name: 'Manx (Isle of Man)' },
    { cultureCode: 'mr', name: 'Marathi' },
    { cultureCode: 'mr-IN', name: 'Marathi (India)' },
    { cultureCode: 'mn', name: 'Mongolian' },
    { cultureCode: 'mn-Cyrl-MN', name: 'Mongolian (Cyrillic, Mongolia)' },
    { cultureCode: 'mn-Cyrl', name: 'Mongolian (Cyrillic)' },
    { cultureCode: 'mn-MN', name: 'Mongolian (Mongolia)' },
    { cultureCode: 'ne', name: 'Nepali' },
    { cultureCode: 'ne-IN', name: 'Nepali (India)' },
    { cultureCode: 'ne-NP', name: 'Nepali (Nepal)' },
    { cultureCode: 'nd', name: 'North Ndebele' },
    { cultureCode: 'nd-ZW', name: 'North Ndebele (Zimbabwe)' },
    { cultureCode: 'se', name: 'Northern Sami' },
    { cultureCode: 'se-FI', name: 'Northern Sami (Finland)' },
    { cultureCode: 'se-NO', name: 'Northern Sami (Norway)' },
    { cultureCode: 'se-SE', name: 'Northern Sami (Sweden)' },
    { cultureCode: 'no', name: 'Norwegian' },
    { cultureCode: 'no-NO', name: 'Norwegian (Norway)' },
    { cultureCode: 'nb', name: 'Norwegian Bokmål' },
    { cultureCode: 'nb-NO', name: 'Norwegian Bokmål (Norway)' },
    { cultureCode: 'nb-SJ', name: 'Norwegian Bokmål (Svalbard & Jan Mayen)' },
    { cultureCode: 'nn', name: 'Norwegian Nynorsk' },
    { cultureCode: 'nn-NO', name: 'Norwegian Nynorsk (Norway)' },
    { cultureCode: 'or', name: 'Oriya' },
    { cultureCode: 'or-IN', name: 'Oriya (India)' },
    { cultureCode: 'om', name: 'Oromo' },
    { cultureCode: 'om-ET', name: 'Oromo (Ethiopia)' },
    { cultureCode: 'om-KE', name: 'Oromo (Kenya)' },
    { cultureCode: 'os', name: 'Ossetic' },
    { cultureCode: 'os-GE', name: 'Ossetic (Georgia)' },
    { cultureCode: 'os-RU', name: 'Ossetic (Russia)' },
    { cultureCode: 'ps', name: 'Pashto' },
    { cultureCode: 'ps-AF', name: 'Pashto (Afghanistan)' },
    { cultureCode: 'fa', name: 'Persian' },
    { cultureCode: 'fa-AF', name: 'Persian (Afghanistan)' },
    { cultureCode: 'fa-IR', name: 'Persian (Iran)' },
    { cultureCode: 'pl', name: 'Polish' },
    { cultureCode: 'pl-PL', name: 'Polish (Poland)' },
    { cultureCode: 'pt', name: 'Portuguese' },
    { cultureCode: 'pt-AO', name: 'Portuguese (Angola)' },
    { cultureCode: 'pt-BR', name: 'Portuguese (Brazil)' },
    { cultureCode: 'pt-CV', name: 'Portuguese (Cape Verde)' },
    { cultureCode: 'pt-GW', name: 'Portuguese (Guinea-Bissau)' },
    { cultureCode: 'pt-MO', name: 'Portuguese (Macau SAR China)' },
    { cultureCode: 'pt-MZ', name: 'Portuguese (Mozambique)' },
    { cultureCode: 'pt-PT', name: 'Portuguese (Portugal)' },
    { cultureCode: 'pt-ST', name: 'Portuguese (São Tomé & Príncipe)' },
    { cultureCode: 'pt-TL', name: 'Portuguese (Timor-Leste)' },
    { cultureCode: 'pa', name: 'Punjabi' },
    { cultureCode: 'pa-Arab-PK', name: 'Punjabi (Arabic, Pakistan)' },
    { cultureCode: 'pa-Arab', name: 'Punjabi (Arabic)' },
    { cultureCode: 'pa-Guru-IN', name: 'Punjabi (Gurmukhi, India)' },
    { cultureCode: 'pa-Guru', name: 'Punjabi (Gurmukhi)' },
    { cultureCode: 'pa-IN', name: 'Punjabi (India)' },
    { cultureCode: 'pa-PK', name: 'Punjabi (Pakistan)' },
    { cultureCode: 'qu', name: 'Quechua' },
    { cultureCode: 'qu-BO', name: 'Quechua (Bolivia)' },
    { cultureCode: 'qu-EC', name: 'Quechua (Ecuador)' },
    { cultureCode: 'qu-PE', name: 'Quechua (Peru)' },
    { cultureCode: 'ro', name: 'Romanian' },
    { cultureCode: 'ro-MD', name: 'Romanian (Moldova)' },
    { cultureCode: 'ro-RO', name: 'Romanian (Romania)' },
    { cultureCode: 'rm', name: 'Romansh' },
    { cultureCode: 'rm-CH', name: 'Romansh (Switzerland)' },
    { cultureCode: 'rn', name: 'Rundi' },
    { cultureCode: 'rn-BI', name: 'Rundi (Burundi)' },
    { cultureCode: 'ru', name: 'Russian' },
    { cultureCode: 'ru-BY', name: 'Russian (Belarus)' },
    { cultureCode: 'ru-KZ', name: 'Russian (Kazakhstan)' },
    { cultureCode: 'ru-KG', name: 'Russian (Kyrgyzstan)' },
    { cultureCode: 'ru-MD', name: 'Russian (Moldova)' },
    { cultureCode: 'ru-RU', name: 'Russian (Russia)' },
    { cultureCode: 'ru-UA', name: 'Russian (Ukraine)' },
    { cultureCode: 'sg', name: 'Sango' },
    { cultureCode: 'sg-CF', name: 'Sango (Central African Republic)' },
    { cultureCode: 'gd', name: 'Scottish Gaelic' },
    { cultureCode: 'gd-GB', name: 'Scottish Gaelic (United Kingdom)' },
    { cultureCode: 'sr', name: 'Serbian' },
    { cultureCode: 'sr-BA', name: 'Serbian (Bosnia & Herzegovina)' },
    { cultureCode: 'sr-Cyrl-BA', name: 'Serbian (Cyrillic, Bosnia & Herzegovina)' },
    { cultureCode: 'sr-Cyrl-XK', name: 'Serbian (Cyrillic, Kosovo)' },
    { cultureCode: 'sr-Cyrl-ME', name: 'Serbian (Cyrillic, Montenegro)' },
    { cultureCode: 'sr-Cyrl-RS', name: 'Serbian (Cyrillic, Serbia)' },
    { cultureCode: 'sr-Cyrl', name: 'Serbian (Cyrillic)' },
    { cultureCode: 'sr-XK', name: 'Serbian (Kosovo)' },
    { cultureCode: 'sr-Latn-BA', name: 'Serbian (Latin, Bosnia & Herzegovina)' },
    { cultureCode: 'sr-Latn-XK', name: 'Serbian (Latin, Kosovo)' },
    { cultureCode: 'sr-Latn-ME', name: 'Serbian (Latin, Montenegro)' },
    { cultureCode: 'sr-Latn-RS', name: 'Serbian (Latin, Serbia)' },
    { cultureCode: 'sr-Latn', name: 'Serbian (Latin)' },
    { cultureCode: 'sr-ME', name: 'Serbian (Montenegro)' },
    { cultureCode: 'sr-RS', name: 'Serbian (Serbia)' },
    { cultureCode: 'sh', name: 'Serbo-Croatian' },
    { cultureCode: 'sh-BA', name: 'Serbo-Croatian (Bosnia & Herzegovina)' },
    { cultureCode: 'sn', name: 'Shona' },
    { cultureCode: 'sn-ZW', name: 'Shona (Zimbabwe)' },
    { cultureCode: 'ii', name: 'Sichuan Yi' },
    { cultureCode: 'ii-CN', name: 'Sichuan Yi (China)' },
    { cultureCode: 'si', name: 'Sinhala' },
    { cultureCode: 'si-LK', name: 'Sinhala (Sri Lanka)' },
    { cultureCode: 'sk', name: 'Slovak' },
    { cultureCode: 'sk-SK', name: 'Slovak (Slovakia)' },
    { cultureCode: 'sl', name: 'Slovenian' },
    { cultureCode: 'sl-SI', name: 'Slovenian (Slovenia)' },
    { cultureCode: 'so', name: 'Somali' },
    { cultureCode: 'so-DJ', name: 'Somali (Djibouti)' },
    { cultureCode: 'so-ET', name: 'Somali (Ethiopia)' },
    { cultureCode: 'so-KE', name: 'Somali (Kenya)' },
    { cultureCode: 'so-SO', name: 'Somali (Somalia)' },
    { cultureCode: 'es', name: 'Spanish' },
    { cultureCode: 'es-AR', name: 'Spanish (Argentina)' },
    { cultureCode: 'es-BO', name: 'Spanish (Bolivia)' },
    { cultureCode: 'es-IC', name: 'Spanish (Canary Islands)' },
    { cultureCode: 'es-EA', name: 'Spanish (Ceuta & Melilla)' },
    { cultureCode: 'es-CL', name: 'Spanish (Chile)' },
    { cultureCode: 'es-CO', name: 'Spanish (Colombia)' },
    { cultureCode: 'es-CR', name: 'Spanish (Costa Rica)' },
    { cultureCode: 'es-CU', name: 'Spanish (Cuba)' },
    { cultureCode: 'es-DO', name: 'Spanish (Dominican Republic)' },
    { cultureCode: 'es-EC', name: 'Spanish (Ecuador)' },
    { cultureCode: 'es-SV', name: 'Spanish (El Salvador)' },
    { cultureCode: 'es-GQ', name: 'Spanish (Equatorial Guinea)' },
    { cultureCode: 'es-GT', name: 'Spanish (Guatemala)' },
    { cultureCode: 'es-HN', name: 'Spanish (Honduras)' },
    { cultureCode: 'es-MX', name: 'Spanish (Mexico)' },
    { cultureCode: 'es-NI', name: 'Spanish (Nicaragua)' },
    { cultureCode: 'es-PA', name: 'Spanish (Panama)' },
    { cultureCode: 'es-PY', name: 'Spanish (Paraguay)' },
    { cultureCode: 'es-PE', name: 'Spanish (Peru)' },
    { cultureCode: 'es-PH', name: 'Spanish (Philippines)' },
    { cultureCode: 'es-PR', name: 'Spanish (Puerto Rico)' },
    { cultureCode: 'es-ES', name: 'Spanish (Spain)' },
    { cultureCode: 'es-US', name: 'Spanish (United States)' },
    { cultureCode: 'es-UY', name: 'Spanish (Uruguay)' },
    { cultureCode: 'es-VE', name: 'Spanish (Venezuela)' },
    { cultureCode: 'sw', name: 'Swahili' },
    { cultureCode: 'sw-KE', name: 'Swahili (Kenya)' },
    { cultureCode: 'sw-TZ', name: 'Swahili (Tanzania)' },
    { cultureCode: 'sw-UG', name: 'Swahili (Uganda)' },
    { cultureCode: 'sv', name: 'Swedish' },
    { cultureCode: 'sv-AX', name: 'Swedish (Åland Islands)' },
    { cultureCode: 'sv-FI', name: 'Swedish (Finland)' },
    { cultureCode: 'sv-SE', name: 'Swedish (Sweden)' },
    { cultureCode: 'tl', name: 'Tagalog' },
    { cultureCode: 'tl-PH', name: 'Tagalog (Philippines)' },
    { cultureCode: 'ta', name: 'Tamil' },
    { cultureCode: 'ta-IN', name: 'Tamil (India)' },
    { cultureCode: 'ta-MY', name: 'Tamil (Malaysia)' },
    { cultureCode: 'ta-SG', name: 'Tamil (Singapore)' },
    { cultureCode: 'ta-LK', name: 'Tamil (Sri Lanka)' },
    { cultureCode: 'te', name: 'Telugu' },
    { cultureCode: 'te-IN', name: 'Telugu (India)' },
    { cultureCode: 'th', name: 'Thai' },
    { cultureCode: 'th-TH', name: 'Thai (Thailand)' },
    { cultureCode: 'bo', name: 'Tibetan' },
    { cultureCode: 'bo-CN', name: 'Tibetan (China)' },
    { cultureCode: 'bo-IN', name: 'Tibetan (India)' },
    { cultureCode: 'ti', name: 'Tigrinya' },
    { cultureCode: 'ti-ER', name: 'Tigrinya (Eritrea)' },
    { cultureCode: 'ti-ET', name: 'Tigrinya (Ethiopia)' },
    { cultureCode: 'to', name: 'Tongan' },
    { cultureCode: 'to-TO', name: 'Tongan (Tonga)' },
    { cultureCode: 'tr', name: 'Turkish' },
    { cultureCode: 'tr-CY', name: 'Turkish (Cyprus)' },
    { cultureCode: 'tr-TR', name: 'Turkish (Turkey)' },
    { cultureCode: 'uk', name: 'Ukrainian' },
    { cultureCode: 'uk-UA', name: 'Ukrainian (Ukraine)' },
    { cultureCode: 'ur', name: 'Urdu' },
    { cultureCode: 'ur-IN', name: 'Urdu (India)' },
    { cultureCode: 'ur-PK', name: 'Urdu (Pakistan)' },
    { cultureCode: 'ug', name: 'Uyghur' },
    { cultureCode: 'ug-Arab-CN', name: 'Uyghur (Arabic, China)' },
    { cultureCode: 'ug-Arab', name: 'Uyghur (Arabic)' },
    { cultureCode: 'ug-CN', name: 'Uyghur (China)' },
    { cultureCode: 'uz', name: 'Uzbek' },
    { cultureCode: 'uz-AF', name: 'Uzbek (Afghanistan)' },
    { cultureCode: 'uz-Arab-AF', name: 'Uzbek (Arabic, Afghanistan)' },
    { cultureCode: 'uz-Arab', name: 'Uzbek (Arabic)' },
    { cultureCode: 'uz-Cyrl-UZ', name: 'Uzbek (Cyrillic, Uzbekistan)' },
    { cultureCode: 'uz-Cyrl', name: 'Uzbek (Cyrillic)' },
    { cultureCode: 'uz-Latn-UZ', name: 'Uzbek (Latin, Uzbekistan)' },
    { cultureCode: 'uz-Latn', name: 'Uzbek (Latin)' },
    { cultureCode: 'uz-UZ', name: 'Uzbek (Uzbekistan)' },
    { cultureCode: 'vi', name: 'Vietnamese' },
    { cultureCode: 'vi-VN', name: 'Vietnamese (Vietnam)' },
    { cultureCode: 'cy', name: 'Welsh' },
    { cultureCode: 'cy-GB', name: 'Welsh (United Kingdom)' },
    { cultureCode: 'fy', name: 'Western Frisian' },
    { cultureCode: 'fy-NL', name: 'Western Frisian (Netherlands)' },
    { cultureCode: 'yi', name: 'Yiddish' },
    { cultureCode: 'yo', name: 'Yoruba' },
    { cultureCode: 'yo-BJ', name: 'Yoruba (Benin)' },
    { cultureCode: 'yo-NG', name: 'Yoruba (Nigeria)' },
    { cultureCode: 'zu', name: 'Zulu' },
    { cultureCode: 'zu-ZA', name: 'Zulu (South Africa)' },
  ],
}

export const getters = {
  dataCultures: state => state.dataCultures,
}
